import { put } from 'redux-saga/effects';
import { resetSecretKeyCommunication } from '../../../effects/organization';

export default function* resetSetSecretKeyCommunication({ payload }) {
  yield put(resetSecretKeyCommunication({ appId: payload.appId }));
}
